"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as t, jsxs as X } from "react/jsx-runtime";
import * as b from "react";
import m from "classnames";
import { BaseTouchable as te } from "./touchable.js";
import { Text3 as xe, Text1 as ve, Text2 as Y } from "./text.js";
import o from "./box.js";
import C from "./stack.js";
import ge from "./badge.js";
import { useAriaId as ye } from "./hooks.js";
import { useIsInverseVariant as oe } from "./theme-variant-context.js";
import we from "./icons/icon-chevron.js";
import Be from "./switch-component.js";
import ae, { useRadioContext as Re } from "./radio-button.js";
import Ie from "./checkbox.js";
import { Boxed as Ce } from "./boxed.js";
import Te from "./divider.js";
import { getPrefixedDataAttributes as K } from "./utils/dom.js";
import { rowContent as q, touchableBackground as z, touchableBackgroundInverse as G, pointer as re, content as Ne, center as J, disabled as I, asset as ke, rowBody as Le, badge as Ae, rightContent as Se, rightRestrictedWidth as Ve, detail as Xe, detailRight as Ee, dualActionContainer as Pe, dualActionLeft as De, dualActionDivider as We, dualActionRight as je } from "./list.css-mistica.js";
import { vars as Me } from "./image.css-mistica.js";
import { vars as d } from "./skins/skin-contract.css-mistica.js";
import { applyCssVars as Oe } from "./utils/css.js";
import { IconButton as ie, ToggleIconButton as ne } from "./icon-button.js";
import { sprinkles as He } from "./sprinkles.css-mistica.js";
const Fe = (e, a)=>typeof e == "function" ? e == null ? void 0 : e({
        centerY: a
    }) : a ? /* @__PURE__ */ t("div", {
        style: {
            display: "flex",
            alignItems: "center",
            height: "100%"
        },
        children: /* @__PURE__ */ t("div", {
            children: e
        })
    }) : e, Ye = (param)=>{
    let { withChevron: e, headline: a, headlineRef: r, extraRef: l, title: c, titleAs: v, titleLinesMax: g, subtitle: x, subtitleLinesMax: P, description: w, descriptionLinesMax: D, detail: h, asset: E, danger: T, badge: N, right: y, rightRef: u, extra: k, labelId: W, disabled: s, control: L } = param;
    const A = oe(), S = [
        a,
        c,
        x,
        w,
        k
    ].filter(Boolean).length === 1;
    return /* @__PURE__ */ X(o, {
        paddingY: 16,
        className: Ne,
        id: W,
        children: [
            E && /* @__PURE__ */ t(o, {
                paddingRight: 16,
                className: m({
                    [J]: S,
                    [I]: s
                }),
                "aria-hidden": !0,
                children: /* @__PURE__ */ t("div", {
                    className: ke,
                    style: Oe({
                        color: T ? A ? d.colors.textErrorInverse : d.colors.textError : A ? d.colors.textPrimaryInverse : d.colors.textPrimary,
                        [Me.mediaBorderRadius]: d.borderRadii.mediaSmall
                    }),
                    children: E
                })
            }),
            /* @__PURE__ */ X("div", {
                className: m(Le, {
                    [I]: s
                }),
                style: {
                    justifyContent: S ? "center" : "flex-start"
                },
                children: [
                    /* @__PURE__ */ t(xe, {
                        regular: !0,
                        color: T ? d.colors.textError : d.colors.textPrimary,
                        truncate: g,
                        hyphens: "auto",
                        as: v,
                        children: c
                    }),
                    a && /* @__PURE__ */ t("div", {
                        ref: r,
                        style: {
                            order: -1,
                            paddingBottom: 4
                        },
                        children: /* @__PURE__ */ t(ve, {
                            regular: !0,
                            color: d.colors.textPrimary,
                            hyphens: "auto",
                            children: a
                        })
                    }),
                    x && /* @__PURE__ */ t(o, {
                        paddingTop: 2,
                        children: /* @__PURE__ */ t(Y, {
                            regular: !0,
                            color: d.colors.textPrimary,
                            truncate: P,
                            hyphens: "auto",
                            children: x
                        })
                    }),
                    w && /* @__PURE__ */ t(o, {
                        paddingTop: 2,
                        children: /* @__PURE__ */ t(Y, {
                            regular: !0,
                            color: d.colors.textSecondary,
                            truncate: D,
                            hyphens: "auto",
                            children: w
                        })
                    }),
                    k && /* @__PURE__ */ t(o, {
                        ref: l,
                        paddingTop: 2,
                        children: k
                    })
                ]
            }),
            N && /* @__PURE__ */ t(o, {
                paddingLeft: 16,
                children: /* @__PURE__ */ t("div", {
                    className: m(Ae, {
                        [I]: s
                    }),
                    children: /* @__PURE__ */ t(ge, {
                        value: N === !0 ? void 0 : N
                    })
                })
            }),
            (h || y || e || L) && /* @__PURE__ */ X("div", {
                className: m(Se, {
                    [Ve]: !!h
                }),
                children: [
                    h && /* @__PURE__ */ t("div", {
                        className: m(Xe, {
                            [I]: s
                        }),
                        children: /* @__PURE__ */ t(Y, {
                            regular: !0,
                            color: d.colors.textSecondary,
                            hyphens: "auto",
                            children: h
                        })
                    }),
                    y && /* @__PURE__ */ t("div", {
                        className: m({
                            [Ee]: !!h,
                            [I]: s
                        }),
                        ref: u,
                        children: Fe(y, S)
                    }),
                    e && /* @__PURE__ */ t(o, {
                        paddingLeft: h || y ? 4 : 0,
                        className: m(J, {
                            [I]: s
                        }),
                        children: /* @__PURE__ */ t(we, {
                            color: A ? d.colors.inverse : d.colors.neutralMedium,
                            direction: "right"
                        })
                    }),
                    L && /* @__PURE__ */ t(o, {
                        paddingLeft: h || y ? 8 : 0,
                        className: J,
                        children: L
                    })
                ]
            })
        ]
    });
}, qe = (param)=>{
    let { value: e, defaultValue: a, onChange: r } = param;
    const l = e !== void 0, [c, v] = b.useState(!!a);
    return [
        l ? !!e : c,
        ()=>{
            l || v(!c), r == null || r(l ? !e : !c);
        }
    ];
}, ze = (e)=>[
        "switch",
        "checkbox",
        "radioValue",
        "iconButton"
    ].some((a)=>e[a] !== void 0), le = /*#__PURE__*/ b.forwardRef((e, a)=>{
    var p, ee;
    const r = ye(), l = oe(), { asset: c, headline: v, title: g, titleAs: x, titleLinesMax: P, subtitle: w, subtitleLinesMax: D, description: h, descriptionLinesMax: E, detail: T, danger: N, badge: y, role: u, extra: k, withChevron: W, dataAttributes: s, right: L, "aria-label": A } = e, [Q, S] = b.useState(""), [de, ce] = b.useState(""), [se, he] = b.useState(""), me = [
        g,
        Q,
        w,
        h,
        de,
        T,
        se
    ].filter(Boolean).join(" "), B = A !== null && A !== void 0 ? A : e.href || e.to ? me : void 0, ue = Re(), f = e.disabled || e.radioValue !== void 0 && ue.disabled, j = !f && !l, M = !f && l, U = ze(e), V = !!e.onPress || !!e.href || !!e.to, fe = U ? !1 : W !== null && W !== void 0 ? W : V, Z = {
        href: e.href,
        newTab: e.newTab,
        loadOnTop: e.loadOnTop,
        to: e.to,
        fullPageOnWebView: e.fullPageOnWebView,
        replace: e.replace,
        onNavigate: e.onNavigate,
        onPress: e.onPress,
        trackingEvent: e.trackingEvent
    }, [_, $] = qe(e.switch || e.checkbox || {}), R = (i)=>/* @__PURE__ */ t(Ye, {
            asset: c,
            headline: v,
            headlineRef: (n)=>{
                n && S(n.textContent || "");
            },
            title: g,
            titleAs: x,
            subtitle: w,
            description: h,
            badge: y,
            titleLinesMax: P,
            subtitleLinesMax: D,
            descriptionLinesMax: E,
            detail: T,
            danger: N,
            right: L,
            rightRef: (n)=>{
                n && he(n.innerText || n.textContent || "");
            },
            control: i == null ? void 0 : i.control,
            extra: k,
            extraRef: (n)=>{
                n && ce(n.innerText || n.textContent || "");
            },
            labelId: i == null ? void 0 : i.labelId,
            disabled: f,
            withChevron: fe
        });
    if (V && !U) return /* @__PURE__ */ t(te, _object_spread_props(_object_spread({
        ref: a,
        className: m(q, {
            [z]: j,
            [G]: M,
            [re]: !f
        })
    }, Z), {
        role: u,
        dataAttributes: s,
        disabled: f,
        "aria-label": B,
        children: /* @__PURE__ */ t(o, {
            paddingX: 16,
            "aria-hidden": !!e.to || !!e.href || void 0,
            children: R()
        })
    }));
    const O = (i)=>/* @__PURE__ */ X("div", _object_spread_props(_object_spread({
            className: Pe,
            ref: a
        }, K(s)), {
            children: [
                /* @__PURE__ */ t(te, _object_spread_props(_object_spread({
                    disabled: f
                }, Z), {
                    role: u,
                    className: m(De, {
                        [z]: j,
                        [G]: M
                    }),
                    "aria-label": B,
                    children: R({
                        labelId: r
                    })
                })),
                /* @__PURE__ */ t("div", {
                    className: We
                }),
                i
            ]
        })), H = (i, n)=>/* @__PURE__ */ t("div", _object_spread_props(_object_spread({
            className: m(q, {
                [z]: j && n,
                [G]: M && n,
                [re]: !f && n
            }),
            ref: a
        }, K(s)), {
            children: i
        }));
    if (e.switch || e.checkbox) {
        var _ref, _ref1;
        const i = e.switch ? Be : Ie, n = (_ref1 = (_ref = (p = e.switch) == null ? void 0 : p.name) !== null && _ref !== void 0 ? _ref : (ee = e.checkbox) == null ? void 0 : ee.name) !== null && _ref1 !== void 0 ? _ref1 : r;
        return V ? O(/* @__PURE__ */ t(i, {
            disabled: f,
            name: n,
            checked: _,
            "aria-label": B,
            "aria-labelledby": r,
            onChange: $,
            render: (param)=>{
                let { controlElement: F } = param;
                return /* @__PURE__ */ t("div", {
                    className: je,
                    children: F
                });
            }
        })) : H(/* @__PURE__ */ t(i, {
            disabled: f,
            name: n,
            checked: _,
            "aria-label": B,
            "aria-labelledby": r,
            onChange: $,
            render: (param)=>{
                let { controlElement: F, labelId: be } = param;
                return /* @__PURE__ */ t(o, {
                    paddingX: 16,
                    role: u,
                    children: R({
                        labelId: be,
                        control: /* @__PURE__ */ t(C, {
                            space: "around",
                            children: F
                        })
                    })
                });
            }
        }), !0);
    }
    return e.radioValue ? V ? O(/* @__PURE__ */ t(ae, {
        value: e.radioValue,
        "aria-label": B,
        "aria-labelledby": r,
        render: (param)=>{
            let { controlElement: i } = param;
            return /* @__PURE__ */ t(C, {
                space: "around",
                children: /* @__PURE__ */ t(o, {
                    paddingX: 16,
                    children: i
                })
            });
        }
    })) : H(/* @__PURE__ */ t(ae, {
        value: e.radioValue,
        "aria-label": B,
        "aria-labelledby": r,
        render: (param)=>{
            let { controlElement: i } = param;
            return /* @__PURE__ */ t(o, {
                paddingX: 16,
                role: u,
                children: R({
                    labelId: r,
                    control: /* @__PURE__ */ t(C, {
                        space: "around",
                        children: i
                    })
                })
            });
        }
    }), !0) : e.iconButton ? V ? O(/* @__PURE__ */ t(o, {
        padding: 16,
        children: /* @__PURE__ */ t(C, {
            space: "around",
            children: e.iconButton.Icon ? /* @__PURE__ */ t(ie, _object_spread_props(_object_spread({}, e.iconButton), {
                disabled: e.disabled
            })) : /* @__PURE__ */ t(ne, _object_spread_props(_object_spread({}, e.iconButton), {
                disabled: e.disabled
            }))
        })
    })) : H(/* @__PURE__ */ t(o, {
        paddingX: 16,
        children: R({
            labelId: r,
            control: /* @__PURE__ */ t(C, {
                space: "around",
                children: e.iconButton.Icon ? /* @__PURE__ */ t(ie, _object_spread_props(_object_spread({}, e.iconButton), {
                    disabled: e.disabled,
                    role: u
                })) : /* @__PURE__ */ t(ne, _object_spread_props(_object_spread({}, e.iconButton), {
                    disabled: e.disabled,
                    role: u
                }))
            })
        })
    })) : /* @__PURE__ */ t(o, {
        paddingX: 16,
        className: q,
        role: u,
        dataAttributes: s,
        ref: a,
        children: R()
    });
}), ut = /*#__PURE__*/ b.forwardRef((_param, l)=>{
    var { dataAttributes: e, role: a = "listitem" } = _param, r = _object_without_properties(_param, [
        "dataAttributes",
        "role"
    ]);
    return /* @__PURE__ */ t("div", {
        role: a,
        className: He({
            width: "100%"
        }),
        children: /* @__PURE__ */ t(le, _object_spread_props(_object_spread({}, r), {
            ref: l,
            dataAttributes: _object_spread({
                "component-name": "Row"
            }, e)
        }))
    });
}), ft = (param)=>{
    let { children: e, ariaLabelledby: a, role: r = "list", dataAttributes: l } = param;
    const c = b.Children.toArray(e).filter(Boolean), v = c.length - 1;
    return /* @__PURE__ */ t("div", _object_spread_props(_object_spread({
        role: r,
        "aria-labelledby": a
    }, K(l, "RowList")), {
        children: c.map((g, x)=>/* @__PURE__ */ X(b.Fragment, {
                children: [
                    g,
                    x < v && /* @__PURE__ */ t(o, {
                        paddingX: 16,
                        children: /* @__PURE__ */ t(Te, {})
                    })
                ]
            }, x))
    }));
}, bt = /*#__PURE__*/ b.forwardRef((_param, r)=>{
    var { dataAttributes: e } = _param, a = _object_without_properties(_param, [
        "dataAttributes"
    ]);
    return /* @__PURE__ */ t(Ce, {
        isInverse: a.isInverse,
        ref: r,
        dataAttributes: _object_spread({
            "component-name": "BoxedRow"
        }, e),
        children: /* @__PURE__ */ t(le, _object_spread({}, a))
    });
}), xt = (param)=>{
    let { children: e, ariaLabelledby: a, role: r = "list", dataAttributes: l } = param;
    return /* @__PURE__ */ t(C, {
        space: 16,
        role: r,
        "aria-labelledby": a,
        dataAttributes: _object_spread({
            "component-name": "BoxedRowList"
        }, l),
        children: e
    });
};
export { bt as BoxedRow, xt as BoxedRowList, Ye as Content, ut as Row, ft as RowList };
